import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forEach } from 'lodash';
import { NgxUiLoaderService } from 'ngx-ui-loader';

// Services
import { CustomersService } from '../../../services/customers.service';
import { SharedService } from '../../../layouts/shared-service';


@Component({
    selector: 'app-recently-added-fuelerlinx-customers',
    styleUrls: ['./recently-added-fuelerlinx-customers.component.scss'],
    templateUrl: './recently-added-fuelerlinx-customers.component.html',
})
export class RecentlyAddedFuelerLinxCustomersdComponent implements OnInit {
    recentlyAddedCustomersDataSource: any = null;
    recentlyAddedCustomersLoader = 'recently-added-customers';
    noRecentlyAddedCustomers: boolean = true;

    constructor(
        private sharedService: SharedService,
        private customersService: CustomersService,
        private NgxUiLoader: NgxUiLoaderService,
        private router: Router) {

    }

    ngOnInit() {
        this.refreshRecentlyAddedCustomersDataSource();
    }

    get keys(): string[] {
        if (this.recentlyAddedCustomersDataSource != null)
            return Object.keys(this.recentlyAddedCustomersDataSource);
    }

    goToCustomerDetails(customer: any): void {
        this.router.navigate(['/default-layout/customers/' + this.recentlyAddedCustomersDataSource[customer]], { queryParams: { tab: 2 } });
    }

    private refreshRecentlyAddedCustomersDataSource() {
        this.NgxUiLoader.startLoader(this.recentlyAddedCustomersLoader);
        this.customersService.getRecentlyAddedCustomers(this.sharedService.currentUser.groupId)
            .subscribe(
                (data: any) => {
                    this.recentlyAddedCustomersDataSource = data;
                    if (Object.keys(this.recentlyAddedCustomersDataSource).length > 0)
                        this.noRecentlyAddedCustomers = false;
                    this.NgxUiLoader.stopLoader(this.recentlyAddedCustomersLoader);
                }
        );
    }
}
